import { useMemo } from 'react';

import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { TEstimate } from '@entities/eventJournal/model/types';
import { useFilterQuery, useGetFilterNames } from '@features/JournalEventsFilters/lib';
import { TFilterItem } from '@features/JournalEventsFilters/model/types';
import { useNuqsArrayQueryState } from '@shared/hooks';

export const useFilterByEstimate = ({ estimatesData }: { estimatesData: TEstimate[] }) => {
    const dataWithNoEstimate = useMemo(
        () => [{ id: 0, name: 'Без сметы' }, ...(estimatesData ?? [])],
        [estimatesData]
    );
    const defaultValues = useGetFilterNames({
        filterData: dataWithNoEstimate,
        queryKey: EventJournalQueries.estimate,
    });
    const { state } = useNuqsArrayQueryState(EventJournalQueries.estimate);

    const data: TFilterItem[] = useMemo(() => {
        const list = dataWithNoEstimate ?? [];
        const selected = new Set(state ?? []);

        return list.map<TFilterItem>((item) => ({
            label: item.name,
            value: String(item.id),
            isChecked: selected.has(String(item.id)),
            imgUrl: '',
        }));
    }, [dataWithNoEstimate, state]);

    const { onFilterClickQuery, clearQueryValue } = useFilterQuery({
        queryKey: EventJournalQueries.estimate,
    });

    const onEstimateClick = (value: string) => {
        console.log('value', value);
        onFilterClickQuery(value);
    };
    const onClearValuesCb = () => {
        void clearQueryValue();
    };

    return {
        data,
        defaultValues,
        onEstimateClick,
        onClearValuesCb,
    };
};
